
import { User as SupabaseUser } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';
import { User } from './types';

export async function fetchUserProfile(supabaseUser: SupabaseUser): Promise<User | null> {
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', supabaseUser.id)
      .single();
    
    if (error) throw error;
    
    // Get subscription tier with type safety
    let typedSubscriptionTier: 'free' | 'personal' | 'premium' | 'elite' | 'professional' = 'free';
    if (data.subscription_tier && ['free', 'personal', 'premium', 'elite', 'professional'].includes(data.subscription_tier)) {
      typedSubscriptionTier = data.subscription_tier as 'free' | 'personal' | 'premium' | 'elite' | 'professional';
    }
    
    // Get provider with type safety
    let typedProvider: 'email' | 'google' | 'apple' = 'email';
    if (data.provider && ['email', 'google', 'apple'].includes(data.provider)) {
      typedProvider = data.provider as 'email' | 'google' | 'apple';
    }
    
    // Create a User object that extends the Supabase User
    const user: User = {
      ...supabaseUser,
      name: data.name || supabaseUser.user_metadata?.name || supabaseUser.email?.split('@')[0] || 'User',
      subscriptionTier: typedSubscriptionTier,
      profileImage: data.profile_image,
      provider: typedProvider
    };
    
    return user;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    
    // If we can't get the profile data, return a basic User
    const user: User = {
      ...supabaseUser,
      name: supabaseUser.user_metadata?.name || supabaseUser.email?.split('@')[0] || 'User'
    };
    
    return user;
  }
}
